import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core'
import {BehaviorSubject, Observable, Subscription} from 'rxjs'
import {take, tap} from 'rxjs/operators'
import {EbAnalyticsService} from 'src/app/features/analytics/services/facades/eb-analytics.service'
import {EB_ICON_TYPE} from '../../../../components/icons/interface/eb-icon-type.enum'
import {EbAuthService} from '../../../auth/services/eb-auth.service'
import {EbProduct, EbProductTypeEnum} from '../../../product/interfaces/eb-product.interface'
import {EbPricesService} from '../../../product/services/facades/eb-prices.service'

@Component({
    selector: 'eb-purchase-product',
    templateUrl: './eb-purchase-product.component.html',
    styleUrls: ['./eb-purchase-product.component.scss'],
    standalone: false
})
export class EbPurchaseProductComponent implements OnInit, OnDestroy {
  _product: EbProduct
  @Input() productCode: string
  @Input() showQuantity = true
  @Input('product')
  set product(product: EbProduct) {
    // enables sub-component add-to-cart to refresh after context of product has changed
    if (this.refreshProduct(product)) {
      this._product = null
      this.cd.detectChanges()
      this._product = product
      this.fetchPrice()
    }
  }

  @Input() iconOnly = false
  @Input() hasPrice = false
  @Input() isAvailable: boolean
  @Input() showSuccessor: boolean
  @Input() showCountOfProductInCart = false
  @Input() favoritesView = false
  @Input() isVariantProduct = EbProductTypeEnum.PARENT
  @Output() newQuantity: EventEmitter<number> = new EventEmitter()
  isUserLoggedIn$: Observable<boolean> = this.userAuth.isUserLoggedIn()
  maxQuantity = 1000
  priceLoading: boolean
  private subscriptions = new Subscription()
  hasValidPrice$ = new BehaviorSubject(false)
  price: number

  constructor(
    protected pricesService: EbPricesService,
    protected cd: ChangeDetectorRef,
    protected userAuth: EbAuthService,
    protected ebAnalyticsService: EbAnalyticsService
  ) {}

  ngOnInit() {
    if (this.hasPrice) {
      this.hasValidPrice$.next(true)
    } else {
      this.fetchPrice()
    }
  }

  get IconType() {
    return EB_ICON_TYPE
  }

  fetchPrice(quantity = 1) {
    this.priceLoading = true
    if (this._product?.orderable) {
      this.subscriptions.add(
        this.pricesService
          .fetchPrice({
            product: this._product.code,
            quantity
          })
          .pipe(
            take(1),
            tap(() => (this.priceLoading = false))
          )
          .subscribe(price => {
            if (price?.items?.[0]?.itemNetPricePerUnit && price?.priceTotalValue?.value > 0) {
              this.hasValidPrice$.next(true)
              this.price = price?.items?.[0]?.itemNetPricePerUnit.value
            } else {
              this.hasValidPrice$.next(false)
            }
            this.cd.detectChanges()
          })
      )
    } else {
      this.hasValidPrice$.next(false)
      this.priceLoading = false
    }
  }

  hasOrderableProduct(product: EbProduct): boolean {
    return product.orderable || (!product.orderable && product.successor !== undefined)
  }

  refreshProduct(product: EbProduct) {
    return (
      !this._product ||
      this._product.code !== product.code ||
      this._product?.productSalesView?.salesText !== product?.productSalesView.salesText
    )
  }

  requestRfpEvent() {
    if(this.isVariantProduct === EbProductTypeEnum.VARIANT){
      this.ebAnalyticsService.requestForQuotation("Variants Page")
    } else {
      this.ebAnalyticsService.requestForQuotation("Parent Page")
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
